import { isAppVersionBelow } from '~/lib/app-version'

const urlParams = new URLSearchParams(window.location.search)

export const language = urlParams.get('language') || 'en' // en, zh_tw, ...

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = urlParams.get('platform') as Platform

export const appVersion = urlParams.get('app_version') ?? '0.0.0'

// Restore relies on native IAP methods (getAllUnclosedTransactions /
// getAllEntitlements) added on iOS 5.3.0; hide the button on older iOS builds.
export const shouldShowRestoreButton = !(
  platform === 'ios' && isAppVersionBelow(appVersion, '5.3.0')
)

export const deviceRegion = urlParams.get('device_region')

export const enterFrom = urlParams.get('enter_from') as null | EnterFrom

export type EnterFrom =
  // exclusive trees
  | 'focus_settings_exclusive_trees'

  // real tree
  | 'real_tree'

  // coin 3x
  | 'home_coin_boost'
  | 'store_coin_boost'
  | 'insufficient_coins'
  | 'focus_result_boost'

  // web shop's coin-3x Plus row (also lands on the coin 3x feature scene)
  | 'shop'

  // time guard
  | 'time_guard_edit_plan'
  | 'time_guard_select_apps'

  // pause
  | 'pause_cover'
  | 'planting_pause'

  // statistics
  | 'statistics'

  // tags
  | 'tag_list_edit'
  | 'focus_settings_create_tag'
  | 'tag_list_create'

  // ad remove
  | 'ad_remove'

  // favorites settings
  | 'focus_settings_favorites'

  // custom phrase
  | 'settings_custom_phrase'

  // focus challenge (opens us in-place via location.href; see ADR 0039)
  | 'focus_challenge'

  // others
  | 'settings'
  | 'home'
  | 'menu'

// if enterFrom is 'exclusive_trees', enterFromMetadata represents the `{"tree_id": 1 }` URL component encoded json string
export const enterFromMetadata = urlParams.get('enter_from_metadata')
